import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { useErrorToast } from '@/components/layers/ReactQueryProvider';
import { Api } from '@/core/api';
import { useCurrentUser } from '@/core/hooks/useCurrentUser';

export const QUERY_KEY_INCIDENTS_TAGS = 'incidents-tags';

export const useIncidentsTagsData = () => {
  const { orgId } = useCurrentUser();

  const { data, ...query } = useQuery({
    queryKey: [QUERY_KEY_INCIDENTS_TAGS, orgId],
    queryFn: () => Api.mapEvents.getIncidentTags({ orgId }),
    placeholderData: [],
  });

  useErrorToast(query);

  return { data, tagsData: isEmpty(data) ? [] : data!, ...query };
};
